"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convert_raw_two_band_pixel_to_rgb;
function convert_raw_two_band_pixel_to_rgb(noDataValue, noDataPixel, scaleFunction1, scaleFunction2, scaleFunction3, pixel) {
  pixel = pixel.slice(0, 3);
  if (pixel.includes(noDataValue)) return noDataPixel;
  return [scaleFunction1(pixel[0]), scaleFunction2(pixel[1]), scaleFunction3(pixel[2])];
}